import React from 'react'
import PropTypes from 'prop-types'
import {Skeleton} from '@chakra-ui/react'

import {toCurrency} from '../../../utils/formatter'
import {retrieveInvoicePaymentInfo} from '../../../api'
import PaymentCore from './PaymentCore'

const Payment = ({onSuccessCC, xeroInvoiceUUID, authenticityToken}) => {
  const [isLoadingPaymentInfo, setIsLoadingPaymentInfo] = React.useState(true)
  const [paymentInformation, setPaymentInformation] = React.useState({})

  React.useEffect(() => {
    if (xeroInvoiceUUID) {
      retrieveInvoicePaymentInfo({xeroInvoiceUUID}).then((data) => {
        setPaymentInformation(data)
        setIsLoadingPaymentInfo(false)
      })
    }
  }, [xeroInvoiceUUID])

  const {invoice, availablePaymentMethods, bankAccount, status} =
    paymentInformation

  const handlePaymentSubmission = React.useCallback(
    async (values) => {
      if (values.type === 'cybersourceCreditCard') {
        onSuccessCC(values.customerAccount)
      }
    },
    [onSuccessCC],
  )

  if (isLoadingPaymentInfo) {
    return (
      <Skeleton
        height="350px"
        width="100%"
        m={2}
        data-testid="payment-core-loading"
      />
    )
  }

  if (invoice && invoice.isPaid) {
    return null
  }

  if (invoice && invoice.isVoided) {
    return null
  }

  if (status === 'not_allowed') {
    return null
  }

  return (
    <PaymentCore
      onSubmitPayment={handlePaymentSubmission}
      invoice={{
        id: invoice.id,
        supplierName: invoice.supplierName,
        supplierCode: invoice.supplierCode,
        amount: toCurrency(invoice.amount.cents),
        dueAmount: toCurrency(invoice.dueAmount.cents),
        number: invoice.number,
      }}
      bankAccount={bankAccount}
      paymentOptions={availablePaymentMethods || {}}
      authenticityToken={authenticityToken}
    />
  )
}

Payment.defaultProps = {
  onSuccessCC: () => {},
}

Payment.propTypes = {
  onSuccessCC: PropTypes.func,
  xeroInvoiceUUID: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
}

export default Payment
